var React = require('react');

function Pulse (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0 0H24V24H0z","key":0}),React.createElement("path",{"d":"M9 7.539L15 21.539 18.659 13 23 13 23 11 17.341 11 15 16.461 9 2.461 5.341 11 1 11 1 13 6.659 13z","key":1})]);
}

Pulse.defaultProps = {"fill":"currentColor","viewBox":"0 0 24 24"};

module.exports = Pulse;

Pulse.default = Pulse;
